import { Component, OnInit, Input } from '@angular/core';
import { LocationInfoOperatingHoursBaseComponent } from '@moduurnv2/libs-orderingapp';
import { Store } from '@ngxs/store';
@Component({
  selector: 'moduurnv2-location-operating-hours',
  templateUrl: './location-operating-hours.component.html',
  styleUrls: ['./location-operating-hours.component.scss'],
})
export class LocationOperatingHoursComponent
  extends LocationInfoOperatingHoursBaseComponent
   {
  constructor(public store: Store) {
    super(store);
  }
}
